export const PdfIcon = () => (
  <svg width="14" height="16" viewBox="0 0 14 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 4.2105V14.7367C14 15.4345 13.3514 16 12.5517 16H1.44829C0.648286 16 0 15.4345 0 14.7367V1.26325C0 0.5655 0.648286 0 1.44829 0H9.17229L14 4.2105Z"
      fill="#CB0606"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9999 3.97475V4.49875H10.0534C9.23623 4.49875 8.85938 3.91875 8.85938 3.2035V0H9.45709L13.9999 3.97475Z"
      fill="#FB8D8D"
    />
  </svg>
);
